import { stringToBool } from '@/services/stringService';

export class PromoBlockModel {
    content?: string;
    gradientColorStart?: string;
    gradientColorEnd?: string;
    solidBackgroundColor?: string;
    desktopContentMargin?: boolean;
    mobileContentMargin?: boolean;
    desktopTextAlign?: string;
    mobileTextAlign?: string;

    constructor(PromoBlockModel?: Partial<PromoBlockModel>) {
        this.content = PromoBlockModel?.content ?? '';
        this.gradientColorStart = PromoBlockModel?.gradientColorStart ?? '';
        this.gradientColorEnd = PromoBlockModel?.gradientColorEnd ?? '';
        this.solidBackgroundColor = PromoBlockModel?.solidBackgroundColor ?? '';
        this.desktopContentMargin = stringToBool(PromoBlockModel?.desktopContentMargin);
        this.mobileContentMargin = stringToBool(PromoBlockModel?.mobileContentMargin);
        this.desktopTextAlign = PromoBlockModel?.desktopTextAlign ?? 'CENTERED';
        this.mobileTextAlign = PromoBlockModel?.mobileTextAlign ?? 'CENTERED';
    }

    get isGradientBackground(): boolean {
        return this.gradientColorStart != '';
    }

    getGradientDirection(isPortraitOrientation: boolean, whichBlock: string) {
        let direction = '';
        if (whichBlock == 'firstBlock') {
            direction = isPortraitOrientation ? 'to bottom' : 'to right';
        } else {
            direction = isPortraitOrientation ? 'to top' : 'to left';
        }
        return direction;
    }

    textAlignDirection(isPortraitOrientation: boolean) {
        this.mobileTextAlign = this.mobileTextAlign == 'CENTERED' ? 'center' : this.mobileTextAlign;
        this.desktopTextAlign = this.desktopTextAlign == 'CENTERED' ? 'center' : this.desktopTextAlign;
        return isPortraitOrientation ? this.mobileTextAlign : this.desktopTextAlign;
    }

    contentBackgroundStyle(isPortraitOrientation: boolean, whichBlock: string) {
        const direction = this.getGradientDirection(isPortraitOrientation, whichBlock);
        if (this.gradientColorStart != 'rgba(0,0,0,0)') {
            return `linear-gradient( ${direction}, ${this.gradientColorStart} 60%, ${this.gradientColorEnd} 100%)`;
        } else {
            return `${this.solidBackgroundColor}`;
        }
    }

    margin(isPortraitOrientation: boolean) {
        if ((isPortraitOrientation && this.mobileContentMargin) || (!isPortraitOrientation && this.desktopContentMargin)) {
            return '20px 20px';
        } else {
            return 'unset';
        }
    }
}
